import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { time } from 'console';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';

@Component({
  selector: 'app-popupsubmit-data',
  templateUrl: './popupsubmit-data.component.html',
  styleUrls: ['./popupsubmit-data.component.css']
})
export class PopupsubmitDataComponent implements OnInit {
  userdetails = {};
  loginSubmit: any;
  date: any;
  monthList: any = [
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' },
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
  ];
  secondFriday: any;
  month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  monthName: any = [];
  monthsList: any;
  formInputfilter: object = { 'month': '' }
  popupReport: any = [];
  attendanceReport: any = [];
  rejectArray: any[];
  popupObj: string;
  statependingData: any;
  urlparams: any;
  usertab: any;
  districtEntityName: any;
  validateEntityName: any;
  adminEntityName: boolean;
  stateEntityName: boolean;
  yearDropDownList: any;
  currentYear: any;
  viewAdminEntityName: boolean;
  constructor(private authservice: AuthloginService,
    private constants: ConstantsModule,
    private router: Router,
    private route: ActivatedRoute,
    private activeModal: NgbActiveModal,
    private submitdataSerivce: SubmitdataService,) { }

  ngOnInit() {
    this.userdetails = this.authservice.checkloginstatus();
    this.getLoginDetails(this.userdetails)
    this.urlparams = this.submitdataSerivce.getWritableObject(this.route.snapshot.params);
    this.usertab = this.urlparams['component'];
    this.monthsList = this.monthList;
    if (this.userdetails != null && this.userdetails != undefined) {
      this.loginSubmit = this.userdetails['loggedUserData']['userProfile']['fname'];
    }
    this.date = new Date();
    this.secondFriday = this.get2ndFriday(this.date.getFullYear(), this.date.getMonth());
    this.monthName = this.month[this.secondFriday.getMonth()];
    this.setCurrentMonthFullName();
    this.getdynamicYears();
    if (this.userdetails && this.userdetails['roles'][0] == 'DISTRICT_GANGA_COMMITTEE') {
      this.getPopupData();
    }
    if (this.userdetails['roles'][0] == "STATE_GANGA_COMMITTEE" || this.userdetails['roles'][0] == "ADMIN" || this.userdetails['roles'][0] == "MISCELLANEOUS_USER") {
      this.formatstateMeetingData();
    }
  }
  getLoginDetails(userdetails: {}) {
    if (userdetails != null && userdetails != undefined) {
      this.districtEntityName = userdetails ? userdetails['roles'] ? userdetails['roles'][0] == "DISTRICT_GANGA_COMMITTEE" : null : null;
      this.validateEntityName = userdetails ? userdetails['roles'] ? userdetails['roles'][0] == "DISTRICT_VALIDATE_MEMBER" : null : null;
      this.adminEntityName = userdetails ? userdetails['roles'] ? userdetails['roles'][0] == "ADMIN" : null : null;
      this.stateEntityName = userdetails ? userdetails['roles'] ? userdetails['roles'][0] == "STATE_GANGA_COMMITTEE" : null : null;
      this.viewAdminEntityName = userdetails ? userdetails['roles'] ? userdetails['roles'][0] == "MISCELLANEOUS_USER" : null : null;
    }
  }
  gotoRoute() {
    let params = {};
    if (this.userdetails['roles'][0] == "STATE_GANGA_COMMITTEE") {
      params = { 'component': 'meetingreport' }
      this.router.navigate(["/submitdata", params]);
    } else {
      params = { 'component': 'meetingmodule' };
      this.router.navigate(["/submitdata", params]);
    }
    this.closeModal();
  }
  get2ndFriday(year, month) {
    var d = new Date(year, month, 1);
    var day = d.getDay();
    d.setDate(13 + (day <= 5 ? -day : 7 - day));
    return d;
  }

  getdynamicYears() {
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if (currentmonth < 3) {
      dropDownYear = (currentYear - 1) + '-' + currentYear;
    } else {
      dropDownYear = currentYear + '-' + (currentYear + 1);
    }
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data => {
      this.yearDropDownList = data['data'];
    });
    this.currentYear = dropDownYear;
  }

  setCurrentMonthFullName() {
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj => {
      if (parseInt(monthObj['key']) == currentmonth + 1) {
        currentmonthObj = monthObj;
      }
    });
    this.formInputfilter['month'] = currentmonthObj['key'];
  }
  defaultRoute() {
    if (this.userdetails && this.userdetails['roles'][0] == 'DISTRICT_GANGA_COMMITTEE') {
      let params = {};
      params = { 'component': 'forminput' };
      this.router.navigate(["/submitdata", params]);
    }
    this.closeModal();
  }
  gotoDefaultRoute() {
    if (this.userdetails && this.userdetails['roles'][0] == 'DISTRICT_VALIDATE_MEMBER') {
      let params = {};
      params = { 'component': 'approvals' };
      this.router.navigate(["/submitdata", params]);
    }
    this.closeModal();
  }
  getPopupData() {
    let popupArray = [];
    let obj = {
      "ay": this.currentYear,
      "subTp": this.formInputfilter['month'],
      "locationName": this.userdetails['loggedUserData']['userProfile']['locationName'],
      "cType": this.constants.LOCATION_CONSTANT.DISTRICT,
      "lu": this.userdetails['loggedUserData']['userProfile']['locationId'],
      "mode" : "dgc"
    };
    this.submitdataSerivce.getAttendantReport(obj).subscribe(data => {
      for (let i = 0; i < data['pendingReport'].length; i++) {
        this.monthList.forEach(element => {
          if (element['key'] == data['pendingReport'][i]) {
            popupArray.push(element['value'])
          }
        });
        this.popupObj = popupArray.join(", ");
      }
    });
  }
  formatstateMeetingData() {
    let obj = {
      "ay": this.currentYear,
      "subTp": this.formInputfilter['month'],
      "pu": this.userdetails['loggedUserData']['userProfile']['stateUUID'],
      "locationName": this.userdetails['loggedUserData']['userProfile']['locationName'],
      "cType": this.constants.LOCATION_CONSTANT.DISTRICT,
      "mode" : "dgc"
    };
    this.submitdataSerivce.getAttendantReport(obj).subscribe(data => {
      // console.log("qazqaz",data);

      for (let i = 0; i < data['pendingReport'].length; i++) {
        this.statependingData = data['pendingReport'][i];
      }
    });
  }
  closeModal() {
    this.activeModal.dismiss('cancel click');
  }

}
